let env, webirm_host;
let store_id,
	stock_market = 'sz',
	stock_code = '301580',
	full_code = 'sz301580';
let logo = require('@/assets/images/logo.png')

/**
 * https://irweb-aidite.comein.cn
 * https://testirweb-aidite.comein.cn
 */

export const isBuild = /(https|http):\/\/(irweb-aidite\.comein\.cn)/i.test(location.href.toLowerCase());
// export const isBuild = true;

// export const isRelease = true;
export const isRelease = false;

// 环境区分
if (isBuild) {
	env = 'production';
	webirm_host = 'https://irm.comein.cn';
	store_id = 22132;
} else {
	env = 'development';
	webirm_host = 'https://testirm.comein.cn';
	store_id = 6766;
}

export const COMEIN_ENV = env;
export const WEBIRM_HOST = webirm_host;

export const COMPANY_NAME = '爱迪特投资者关系';
export const COMPANY_STORE_ID = store_id;
export const COMPANY_STOCK_MARKET = stock_market;
export const COMPANY_STOCK_CODE = stock_code;
export const COMPANY_FULL_CODE = full_code;
export const COMPANY_LOGO = logo;
